"use client";
import Container from "@mui/material/Container";
import useTheme from "@mui/material/styles/useTheme";

import LazyImage from "src/lib/components/salify-next-layout/default/components/LazyImage";
import { H1, Paragraph } from "src/lib/components/salify-next-layout/default/components/Typography";

import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect, useState } from "react";
import SalifyLink from "src/lib/components/link/salify-link";
import { toAssetImages } from "src/lib/utils";
import { StyledBox } from "../header/default/styles";
import { Carousel } from "../salify-next-layout/default/components/carousel";
import { COMMON_DOT_STYLES } from "../salify-next-layout/default/components/carousel/styles";
import { CarouselButton, GridItemOne, GridItemTwo, StyledGrid } from "./default/styles";
import { layoutConstant } from "src/lib/utils/constants";

export type ICarouselItem = {
  id: string;
  title?: string;
  subTitle?: string;
  leftButton?: { text: string; link: string };
  rightButton?: { text: string; link: string };
  backgroundImgUrl?: string;
  imgUrl?: string;
};

export interface VariantProps {
  linkTo: string;
  carouselData: Array<ICarouselItem>;
  mobileImgOff?: boolean;
}

const CarouselSection: React.FC<VariantProps> = ({ linkTo, carouselData, mobileImgOff }) => {
  const { palette } = useTheme();
  const isMobile = useMediaQuery("(max-width:767px)");

  const [carouselDataState, setCarouselDataState] = useState<ICarouselItem[]>([]);

  useEffect(() => {
    setCarouselDataState(
      carouselData.map((data) => {
        if (data.backgroundImgUrl && !mobileImgOff) {
          const backgroundImgUrl = isMobile
            ? data.backgroundImgUrl.replace(".", "-mobile.")
            : data.backgroundImgUrl;
          return {
            ...data,
            backgroundImgUrl,
          };
        }
        return data;
      }),
    );
  }, [carouselData, isMobile]);

  return (
    <StyledBox id="carouselBox">
      <Container
        maxWidth={false}
        sx={{ maxWidth: layoutConstant.containerWidth }}
        disableGutters={true}
      >
        <Carousel
          dots
          arrows={false}
          spaceBetween={0}
          slidesToShow={1}
          arrowStyles={undefined}
          dotColor={palette.primary.main}
          dotStyles={COMMON_DOT_STYLES as any}
          className="mb-[-6px]"
        >
          {carouselDataState.map(
            ({ id, title, subTitle, backgroundImgUrl, leftButton, rightButton, imgUrl }) => (
              <SalifyLink href={linkTo} key={id}>
                {backgroundImgUrl && (
                  <video width="100%" autoPlay muted playsInline loop>
                    <source
                      src="https://s3.ap-southeast-1.amazonaws.com/simplify.nangthom/nangcom.mp4"
                      type="video/mp4"
                    />
                    <track
                      src="/path/to/captions.vtt"
                      kind="subtitles"
                      srcLang="en"
                      label="English"
                    />
                    Your browser does not support the video tag.
                  </video>
                )}
                {/* {backgroundImgUrl && (
                    <LazyImage
                      src={toAssetImages(backgroundImgUrl)}
                      alt={`banner-${id}`}
                      width={isMobile ? 691 : 1600}
                      height={500}
                      style={{
                        borderRadius: 8,
                      }}
                    />
                  )} */}
                <StyledGrid container>
                  <Container maxWidth="lg" sx={{ height: "100%" }}>
                    <GridItemOne
                      item
                      sx={
                        backgroundImgUrl
                          ? { position: "absolute", top: 0, bottom: 0, color: "white" }
                          : null
                      }
                      display={"flex"}
                      flexDirection={"column"}
                      justifyContent={"center"}
                    >
                      <div className="titleBox">
                        <H1>{title}</H1>
                        <Paragraph>{subTitle}</Paragraph>
                      </div>

                      <Grid
                        container
                        spacing={"13px"}
                        justifyContent={{ xs: "center", sm: "flex-start" }}
                      >
                        {leftButton && (
                          <Grid item>
                            <SalifyLink href={leftButton.link}>
                              <CarouselButton variant="contained" color="primary">
                                {leftButton.text}
                              </CarouselButton>
                            </SalifyLink>
                          </Grid>
                        )}
                        {rightButton && (
                          <Grid item>
                            <SalifyLink href={rightButton.link}>
                              <CarouselButton variant="outlined">{rightButton.text}</CarouselButton>
                            </SalifyLink>
                          </Grid>
                        )}
                      </Grid>
                    </GridItemOne>

                    {imgUrl && (
                      <GridItemTwo item md={6} sm={6} xs={12}>
                        <LazyImage
                          priority
                          alt={`${title}`}
                          width={600}
                          height={450}
                          src={imgUrl}
                        />
                      </GridItemTwo>
                    )}
                  </Container>
                </StyledGrid>
              </SalifyLink>
            ),
          )}
        </Carousel>
      </Container>
    </StyledBox>
  );
};

export default CarouselSection;
